import {Observable} from "rxjs";

export class ItemEvent{
  public item;
  public eventName;
  public paramName;
  public paramVal;
  public fileRef;
  public simpleData;
  public methodName;
  public objectVisibility;
  public preparedItemConfig;
  public updatedConfig;
  public infoWindowVisibility;
  public childComponent;
  public paramType;
  public isSilent;
  public withoutMessage = null;
  public isGroupListener;
  public groupConfig;
  public isSelectedRemove;

  constructor(item, eventName) {
    this.item = item;
    this.eventName = eventName;
  }

  getIsSilent(){
    return this.isSilent;
  }

  getIsGroupListener(){
    return this.isGroupListener;
  }
  getGroupConfig(){
    return this.groupConfig;
  }

  getParamType(){
    return this.paramType;
  }

  getComponent(){
    return this.childComponent;
  }

  getShowTag(){
    return this.item.showTag;
  }

  getInfoVisibility(){
    return this.infoWindowVisibility;
  }

  getUpdatedConfig(){
    return this.updatedConfig;
  }

  getPreparedItemConfig(){
    return this.preparedItemConfig;
  }

  getParamName(){
    return this.paramName;
  }

  getRotationDegrees(){
    return this.item.rotationDegrees;
  }

  getFullRotation(){
    return this.item.rotation;
  }
  getParamValue(){
    return this.paramVal;
  }
  getObjectVisibility(){
    return this.objectVisibility;
  }
  getEventName(){
    return this.eventName;
  }

  getMethod(){
    return this.methodName;
  }

  getSimpleDataObject(){
    return this.simpleData.objects[0] || [];
  }

  getFileData(){
    return new Observable((observer)=>{
      if (!this.fileRef){
        observer.error({message: 'This param doesn\'t have files', val: null});
      }

      // console.log('uploadFile options', options);
      if (this.fileRef) {
        var f = this.fileRef; // FileList object


        // Loop through the FileList and render image files as thumbnails.

          // Only process image files.
          if (!f.type.match('image.*')){
            observer.error({message: 'file type not image', val: null});
          }

          var reader = new FileReader();

          // Closure to capture the file information.
          reader.onload = (function(theFile) {
            return function(e) {
              var data = e.target.result.split(';base64,')[1];

              observer.next(data);

              // uploadPhoto.uploadPhoto(item, theFile.name, data, function (response) {
              //   options.value = response;
              //   options.file = [];
              //   setIntoWindowDataForItem(item.hasOwnProperty('parentItem') ? item.parentItem : item);
              // });
            };
          })(f);

          // Read in the image file as a data URL.
          reader.readAsDataURL(f);
      }
      //
      // upload file
      // save file url
      // save object

      // console.log(options);
    });
  }

  getItemInput(){
    return this.item.inputs[this.paramName];
  }

  getItemInputByName(name){
    return this.item.config.getInputByName(name) || null;
  }

  getFixedWidthInputVal(){
    return this.item.inputs['fixedWidth'].value || null;
  }

  isItemWithFixedSize(){
    return this.item.inputs && (this.item.inputs['fixedWidth'] || this.item.inputs['fixedHeight']);
  }

  setItemInputValue(val){
    this.item.inputs[this.paramName].value = val;
  }
}
